(function () {
    'use strict';

    angular
        .module('app.campaignInfluencersManagePage')
        .config(['$stateProvider', '$urlRouterProvider', function($stateProvider){
            $stateProvider.state('home.campaignInfluencersManagePage', {
                    requireLogin: true,
                    url: 'campaign/influencer',
                    templateUrl: 'app/campaign/campaignInfluencersManagePage/campaignInfluencersManagePage.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator', 'User'],
                        navMarker: ['campaign']
                    },
                    controller: 'campaignInfluencersManagePageCtrl'
                });
        }])
})();

